exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".certification-badge-grid .resume-badges {\n  padding: 15px;\n}\n\n.certification-badge-grid .resume-badges.has-dates {\n  height: auto;\n  min-height: 64px;\n}\n\n.has-dates .badge-title {\n  display: block;\n  -webkit-line-clamp: unset;\n  overflow: visible;\n}\n\n.badge-subtitle {\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 1.5;\n  color: rgba(0, 0, 0, 0.54);\n}", ""]);

// exports
